/* VIP Custom Numbers – single pricing source + purchase protection (VIP v147, 2026-10-29)
 *
 * 1. PRICING (the only copy): window.C6D_VARIANTS and window.C6D_getPrice are moved here unchanged from
 *    sections/vip-custom-numbers.liquid. The Custom Numbers builder and the cart checks below both use them,
 *    so there is one pricing table only.
 * 2. VALIDATION: window.VIPCustom.checkLine(line) / checkCart(cart). A custom line is a cart line whose variant
 *    is one of the 9 C6D_VARIANTS tiers (or whose product handle is custom-last-6-digits-number). It is valid only
 *    when "Requested Last 6 Digits" holds exactly 6 digits, its tier equals the builder price for those digits,
 *    and its quantity is 1. Nothing is ever changed or removed automatically: invalid lines are explained and
 *    checkout is paused until the customer removes the line and uses the builder.
 * v147 rev2: the drawer note under the total reads "Custom numbers are normally ready in around 2 weeks" when the cart holds a
 *    custom line (mixed carts name both); other carts keep the drawer's own "Same-day PAC code".
 * 3. THEME GUARDS: cart page and cart drawer messages; checkout links/buttons paused while a custom line is
 *    invalid; Add to Cart / BUY on any card for a custom tier goes to the builder instead; theme adds of a custom
 *    tier without valid digits are refused. Normal numbers, eSIMs and Pre-Order RESERVE are never touched.
 * Loaded synchronously from snippets/vip-cart-drawer.liquid (every page with the site navigation) and from
 * sections/vip-custom-numbers.liquid. Self-guarded, so loading it twice is harmless.
 * v160 (2026-11-01): cart reads are shared through assets/vip-cart-core.js (loaded first), so validation re-uses the
 *   cart the drawer has just read or that came back with a cart change. The drawer's pending "Adding…" line
 *   (.vcd-pending) is ignored here; the custom-line rules are unchanged.
 */
(function () {
  'use strict';
  if (window.VIPCustom) return;

  /* ---------- 1. pricing (moved verbatim from the builder) ---------- */
  // Variant ID map: price tier -> Shopify variant ID
  window.C6D_VARIANTS = {
    350: 57002625237316,
    750: 57106551374148,
    1250: 57106551406916,
    1500: 57106551439684,
    2500: 57106551472452,
    3500: 57106551505220,
    5000: 57106551537988,
    7500: 57106551570756,
    15000: 57106551603524
  };

function C6D_getPrice(val) {
  if (!/^[0-9]{6}$/.test(val)) return null;
  var d = val.split('').map(Number);

  // 1. aaaaaa - all six digits identical
  if (d.every(function(x){ return x === d[0]; })) {
    var allSamePrices = {0:15000, 1:7500, 2:5000, 3:5000, 4:5000, 5:5000, 6:5000, 7:15000, 8:15000, 9:5000};
    return { price: allSamePrices[d[0]], label: 'Premium pattern' };
  }

  // 2. Named exact overrides (specific individual numbers)
  var namedOverrides = {
    '123123': 1250, '321321': 1250, '247247': 1250,
    '911911': 1500, '786786': 2500, '007007': 3500,
    '247365': 1250, '365247': 750
  };
  if (namedOverrides.hasOwnProperty(val)) {
    return { price: namedOverrides[val], label: 'Premium pattern' };
  }

  // 3. a00a00 (e.g. 100100)
  if (d[0] !== 0 && d[0] === d[3] && d[1] === 0 && d[2] === 0 && d[4] === 0 && d[5] === 0) {
    return { price: 1250, label: 'Premium pattern' };
  }

  // 4. abbbbb - first digit different, last 5 identical (e.g. 100000)
  if (d[1] === d[2] && d[2] === d[3] && d[3] === d[4] && d[4] === d[5] && d[0] !== d[1]) {
    return { price: 1500, label: 'Premium pattern' };
  }

  // 5. aaaaab - first 5 identical, last digit different (e.g. 000001)
  if (d[0] === d[1] && d[1] === d[2] && d[2] === d[3] && d[3] === d[4] && d[4] !== d[5]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 6. abbbba - first == last, middle 4 identical (e.g. 100001)
  if (d[0] === d[5] && d[1] === d[2] && d[2] === d[3] && d[3] === d[4] && d[0] !== d[1]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 7. Single nonzero digit at position 2, 3, 4, or 5 only, rest zero
  for (var pos = 1; pos <= 4; pos++) {
    var isSingle = true;
    for (var i = 0; i < 6; i++) {
      if (i === pos) { if (d[i] === 0) { isSingle = false; break; } }
      else { if (d[i] !== 0) { isSingle = false; break; } }
    }
    if (isSingle) return { price: 750, label: 'Premium pattern' };
  }

  // 8. aaabbb - first 3 identical, last 3 identical, distinct (e.g. 000111)
  if (d[0] === d[1] && d[1] === d[2] && d[3] === d[4] && d[4] === d[5] && d[0] !== d[3]) {
    return { price: 1250, label: 'Premium pattern' };
  }

  // 9. aabbbb - first 2 identical, last 4 identical, distinct
  if (d[0] === d[1] && d[2] === d[3] && d[3] === d[4] && d[4] === d[5] && d[0] !== d[2]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 9b. aaaabb - first 4 identical, last 2 identical, distinct
  if (d[0] === d[1] && d[1] === d[2] && d[2] === d[3] && d[4] === d[5] && d[0] !== d[4]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 10. ababab - two-digit cycle repeated 3 times, distinct
  if (d[0] === d[2] && d[2] === d[4] && d[1] === d[3] && d[3] === d[5] && d[0] !== d[1]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 11 & 12. aabbcc family - three pairs
  if (d[0] === d[1] && d[2] === d[3] && d[4] === d[5] && d[0] !== d[2] && d[2] !== d[4]) {
    var a = d[0], b = d[2], c = d[4];
    var ascending  = (b === a + 1 && c === a + 2);
    var descending = (b === a - 1 && c === a - 2);
    if (ascending || descending) {
      return { price: 1250, label: 'Premium pattern' };
    }
    return { price: 750, label: 'Premium pattern' };
  }

  // 13. Any 3-digit block repeated twice (abcabc / abaaba / aabaab / abbabb etc.)
  if (d[0] === d[3] && d[1] === d[4] && d[2] === d[5]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 14. a00b00 (e.g. 100200) - 0 allowed as a/b
  if (d[1] === 0 && d[2] === 0 && d[4] === 0 && d[5] === 0 && d[0] !== d[3]) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 15. a0b0c0 (e.g. 102030) - 0 allowed as a/b/c
  if (d[1] === 0 && d[3] === 0 && d[5] === 0) {
    return { price: 750, label: 'Premium pattern' };
  }

  // 16. Straight run (ascending or descending consecutive digits)
  if (val === '678910') {
    return { price: 1250, label: 'Premium pattern' };
  }
  var ascStraight = true, descStraight = true;
  for (var i = 1; i < 6; i++) {
    if (d[i] !== d[i-1] + 1) ascStraight = false;
    if (d[i] !== d[i-1] - 1) descStraight = false;
  }
  if (ascStraight || descStraight) {
    if (val === '123456') return { price: 2500, label: 'Premium pattern' };
    return { price: 1500, label: 'Premium pattern' };
  }

  return null;
}

  window.C6D_getPrice = C6D_getPrice;

  /* ---------- 2. validation ---------- */
  var HANDLE = 'custom-last-6-digits-number';
  var PROP = 'Requested Last 6 Digits';
  var BUILDER = '/pages/custom-numbers';
  var BASE = 350;                       // the builder's price when no premium pattern matches
  var TIER_BY_VID = {};
  Object.keys(window.C6D_VARIANTS).forEach(function (k) { TIER_BY_VID[window.C6D_VARIANTS[k]] = +k; });

  function gbp(n) { return '£' + Number(n).toLocaleString('en-GB'); }
  function isCustomVid(vid) { return TIER_BY_VID.hasOwnProperty(+vid); }
  function isCustomLine(it) { return !!it && (isCustomVid(it.variant_id) || it.handle === HANDLE); }
  function expectedTier(d) { var r = C6D_getPrice(d); return r ? r.price : BASE; }
  function digitsOf(it) { return String((it && it.properties && it.properties[PROP]) || '').trim(); }

  // null = fine (or not a custom line); otherwise { code, title, text }
  function checkLine(it) {
    if (!isCustomLine(it)) return null;
    var d = digitsOf(it);
    var tier = TIER_BY_VID[+it.variant_id];
    var fix = 'Please remove this line, then choose your digits in the Custom Numbers builder, which adds the correct price for you.';
    if (!d) return { code: 'missing', title: 'Your six digits are missing', text: 'This custom number has no requested digits, so we would not know which number to source. ' + fix };
    if (!/^[0-9]{6}$/.test(d)) return { code: 'invalid', title: 'These digits are not valid', text: 'The requested digits must be exactly 6 numbers (0–9). ' + fix };
    if (!tier) return { code: 'tier', title: 'Price option not recognised', text: 'This custom number has an unknown price option. ' + fix };
    var exp = expectedTier(d);
    if (tier !== exp) return { code: 'tier', title: 'Price does not match your digits', text: 'The price for 07XXX ' + d + ' is ' + gbp(exp) + ', but this line was added at ' + gbp(tier) + '. ' + fix, expected: exp, actual: tier };
    if (it.quantity > 1) return { code: 'qty', title: 'Quantity must be 1', text: 'Each requested number can only be ordered once. Please remove this line and add 07XXX ' + d + ' again from the Custom Numbers builder.' };
    return null;
  }
  function checkCart(cart) {
    var problems = [];
    var hasCustom = false;
    ((cart && cart.items) || []).forEach(function (it, i) {
      if (isCustomLine(it)) hasCustom = true;
      var p = checkLine(it);
      if (p) problems.push({ index: i, key: it.key, item: it, issue: p });
    });
    return { ok: problems.length === 0, hasCustom: hasCustom, problems: problems };
  }

  /* ---------- cart state (kept fresh; nothing is ever modified) ---------- */
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var state = { status: 'unknown', result: null, seq: 0 };   // status: unknown | ok | bad
  var listeners = [];
  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function validate() {
    var my = ++state.seq;
    return getCart().then(function (cart) {
      var res = checkCart(cart);
      res.cart = cart;
      if (my === state.seq) {
        state.result = res;
        state.status = res.ok ? 'ok' : 'bad';
        listeners.forEach(function (fn) { try { fn(res); } catch (e) {} });
      }
      return res;
    });
  }
  function onChange(fn) { listeners.push(fn); if (state.result) { try { fn(state.result); } catch (e) {} } }
  // Where should a "go to checkout" end up? '/cart' while a custom line needs fixing.
  function checkoutTarget(href) {
    href = href || '/checkout';
    return validate().then(function (r) { return r.ok ? href : '/cart'; }, function () { return href; });
  }

  /* ---------- 3a. theme adds: a custom tier needs valid digits and the matching tier ---------- */
  function cartKind(url) {
    var p = '';
    try { p = new URL(url, location.href).pathname.replace(/\/+$/, ''); } catch (e) {}
    if (/\/cart\/add(\.js)?$/.test(p)) return 'add';
    if (/\/cart\/(change|update|clear)(\.js)?$/.test(p)) return 'mutate';
    return null;
  }
  function addProblem(body) {
    var items = [];
    try {
      if (typeof body === 'string' && body.trim().charAt(0) === '{') {
        var j = JSON.parse(body);
        items = (j.items && j.items.length) ? j.items : [j];
      } else if (typeof body === 'string') {
        var sp = new URLSearchParams(body);
        var props = {}; props[PROP] = sp.get('properties[' + PROP + ']');
        items = [{ id: sp.get('id'), quantity: sp.get('quantity'), properties: props }];
      } else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
        var p2 = {}; p2[PROP] = body.get('properties[' + PROP + ']');
        items = [{ id: body.get('id'), quantity: body.get('quantity'), properties: p2 }];
      }
    } catch (e) { return null; }
    for (var i = 0; i < items.length; i++) {
      var x = items[i] || {};
      if (!isCustomVid(x.id)) continue;
      var p = checkLine({ variant_id: +x.id, quantity: +(x.quantity || 1), properties: x.properties || {} });
      if (p) return p;
    }
    return null;
  }
  function refuse(p) {
    return new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: 'Please choose your six digits in the Custom Numbers builder (' + BUILDER + '). ' + (p ? p.title + '.' : '') }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    });
  }
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var k = method === 'POST' ? cartKind(url) : null;
      if (!k) return nativeFetch(input, init);
      if (k === 'add') {
        var p = addProblem(init && init.body);
        if (p) return Promise.resolve(refuse(p));
      }
      state.status = 'unknown';
      var req = nativeFetch(input, init);
      req.then(function () { validate().catch(function () {}); }, function () { validate().catch(function () {}); });
      return req;
    };
  }
  try {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__vipcKind = String(m).toUpperCase() === 'POST' ? cartKind(u) : null; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__vipcKind) { state.status = 'unknown'; this.addEventListener('loadend', function () { validate().catch(function () {}); }); }
      return XS.apply(this, arguments);
    };
  } catch (e) {}

  /* ---------- 3b. clicks: card Add to Cart / BUY for a custom tier -> builder; checkout paused while invalid ---------- */
  function isCheckoutLink(a) {
    try { var u = new URL(a.href, location.href); return u.origin === location.origin && /^\/checkouts?(\/|$)/.test(u.pathname); } catch (e) { return false; }
  }
  var bypass = false;
  function goBuilder(e) { e.preventDefault(); e.stopImmediatePropagation(); location.href = BUILDER; }
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // Card / search-panel buttons that would add a custom tier directly
    var s = t.closest('.vip-num-add[data-vid]');
    if (s && isCustomVid(s.getAttribute('data-vid'))) return goBuilder(e);
    var b = t.closest('[onclick*="addToCart("],[onclick*="AddToCart("],[onclick*="pdpBuyNow("]');
    if (b) {
      var m = (b.getAttribute('onclick') || '').match(/(?:addToCart|pdpBuyNow)\(\s*['"]?(\d+)/i);
      if (m && isCustomVid(m[1])) return goBuilder(e);
      return;
    }
    // Anything this script (or templates/cart.liquid) has paused
    if (t.closest('.vipc-blocked')) { e.preventDefault(); e.stopImmediatePropagation(); showBlocked(); return; }
    // Checkout links and buttons
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = t.closest('a[href]');
    var btn = !a && t.closest('button[name="checkout"],input[name="checkout"]');
    if (!(a && isCheckoutLink(a)) && !btn) return;
    if (state.status === 'ok' || bypass) { bypass = false; return; }   // valid: the normal checkout handlers run unchanged
    e.preventDefault(); e.stopImmediatePropagation();
    if (state.status === 'bad') { showBlocked(); return; }
    var el = a || btn;
    var resume = function () { bypass = true; el.click(); };   // replay the click so the existing checkout handlers run
    validate().then(function (r) { if (!r.ok) { showBlocked(); return; } resume(); }, resume);
  }, true);
  // Non-AJAX product forms posting a custom tier without digits
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || cartKind(f.action) !== 'add') return;
    var idEl = f.querySelector('[name="id"]');
    if (!idEl || !isCustomVid(idEl.value)) return;
    var pEl = f.querySelector('[name="properties[' + PROP + ']"]');
    var p = checkLine({ variant_id: +idEl.value, quantity: 1, properties: (function () { var o = {}; o[PROP] = pEl ? pEl.value : ''; return o; })() });
    if (p) { e.preventDefault(); e.stopImmediatePropagation(); location.href = BUILDER; }
  }, true);

  /* ---------- 3c. messages: cart page and cart drawer ---------- */
  var CSS = [
    '.vipc-issue{box-sizing:border-box;margin:10px 0 2px;padding:11px 13px;border:1px solid #e0a95f;border-left:3px solid #c0392b;background:#fff8ec;color:#5a3a12;font-family:Jost,sans-serif;font-size:13px;line-height:1.55;letter-spacing:.01em;flex-basis:100%;width:100%}',
    '.vipc-issue strong{display:block;color:#8a2a1e;font-weight:600;margin-bottom:2px}',
    '.vipc-issue a{color:#8a5a12!important;text-decoration:underline!important;text-underline-offset:3px;font-weight:600}',
    '#vcdDrawer .vipc-issue{background:rgba(224,122,106,.08);border-color:rgba(224,122,106,.55);border-left-color:#e07a6a;color:#f0c9bf}',
    '#vcdDrawer .vipc-issue strong{color:#f0a597}',
    '#vcdDrawer .vipc-issue a{color:#d4b85e!important}',
    '.vipc-req{display:block;margin-top:4px;font-size:12px;letter-spacing:.06em;color:#8f897b}',
    '.vipc-paused{box-sizing:border-box;margin:0 0 12px;padding:11px 13px;border:1px solid #e0a95f;background:#fff8ec;color:#5a3a12;font-family:Jost,sans-serif;font-size:13px;line-height:1.5}',
    '#vcdDrawer .vipc-paused{background:rgba(224,122,106,.08);border-color:rgba(224,122,106,.55);color:#f0c9bf}',
    '.vipc-paused.flash{animation:vipcflash .9s ease 1}',
    '@keyframes vipcflash{0%,100%{box-shadow:none}40%{box-shadow:0 0 0 3px rgba(224,122,106,.55)}}',
    'a.vipc-blocked,button.vipc-blocked{opacity:.45!important;cursor:not-allowed!important;filter:grayscale(.4)}',
    '@media (prefers-reduced-motion:reduce){.vipc-paused.flash{animation:none}}'
  ].join('\n');
  function addStyles() {
    if (document.getElementById('vipcStyles')) return;
    var st = document.createElement('style'); st.id = 'vipcStyles'; st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  function issueBox(p) {
    var d = document.createElement('div');
    d.className = 'vipc-issue'; d.setAttribute('role', 'alert');
    var s = document.createElement('strong'); s.textContent = p.title; d.appendChild(s);
    d.appendChild(document.createTextNode(p.text + ' '));
    var a = document.createElement('a'); a.href = BUILDER; a.textContent = 'Open the Custom Numbers builder'; d.appendChild(a);
    return d;
  }
  function pausedBox() {
    var d = document.createElement('div');
    d.className = 'vipc-paused'; d.setAttribute('role', 'status');
    d.textContent = 'Checkout is paused until the custom number marked above is corrected. Nothing in your cart has been changed.';
    return d;
  }
  function showBlocked() {
    addStyles();
    if (/^\/cart\/?$/.test(location.pathname)) {
      var n = document.querySelector('.vip-summary-box .vipc-paused');
      var first = document.querySelector('.vip-cart-item .vipc-issue');
      if (first && first.scrollIntoView) { try { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }
      if (n) { n.classList.remove('flash'); void n.offsetWidth; n.classList.add('flash'); }
      return;
    }
    var open = document.getElementById('vcdDrawer') && document.getElementById('vcdDrawer').classList.contains('open');
    if (open) {
      var p = document.querySelector('#vcdDrawer .vipc-paused');
      if (p) { p.classList.remove('flash'); void p.offsetWidth; p.classList.add('flash'); }
      return;
    }
    location.href = '/cart';
  }
  function setBlocked(el, blocked) {
    if (!el) return;
    if (blocked) { el.classList.add('vipc-blocked'); el.setAttribute('aria-disabled', 'true'); }
    else { el.classList.remove('vipc-blocked'); el.removeAttribute('aria-disabled'); }
  }

  // Cart page: lines carry data-vipc-key (templates/cart.liquid)
  function paintCartPage(res) {
    var rows = document.querySelectorAll('.vip-cart-item[data-vipc-key]');
    if (!rows.length) return;
    addStyles();
    var byKey = {};
    res.problems.forEach(function (p) { byKey[p.key] = p.issue; });
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var old = row.querySelector('.vipc-issue');
      if (old) old.parentNode.removeChild(old);
      var p = byKey[row.getAttribute('data-vipc-key')];
      if (p) { row.style.flexWrap = 'wrap'; row.appendChild(issueBox(p)); }
    }
    var co = document.getElementById('vipCheckoutBtn');
    var box = document.querySelector('.vip-summary-box');
    var paused = box && box.querySelector('.vipc-paused');
    if (!res.ok) {
      if (box && !paused && co) co.parentNode.insertBefore(pausedBox(), co);
    } else if (paused) {
      paused.parentNode.removeChild(paused);
    }
    setBlocked(co, !res.ok);
    // Manual payment routes on the cart page (USDT / bank transfer) are paused the same way
    var manual = document.querySelectorAll('[data-vipc-manual]');
    for (var j = 0; j < manual.length; j++) {
      setBlocked(manual[j], !res.ok);
      if (!res.ok) { var pnl = document.getElementById(manual[j].getAttribute('data-vipc-manual')); if (pnl) pnl.style.display = 'none'; }
    }
  }
  // Cart drawer (assets/vip-cart-drawer.js renders .vcd-line rows in cart order)
  function paintDrawer(res) {
    var dr = document.getElementById('vcdDrawer');
    if (!dr || !res || !res.cart) return;
    var lines = dr.querySelectorAll('.vcd-body .vcd-line:not(.vcd-pending)');
    var items = res.cart.items || [];
    if (lines.length !== items.length) return;           // drawer still rendering an older cart: wait for the next render
    addStyles();
    var byIndex = {};
    res.problems.forEach(function (p) { byIndex[p.index] = p.issue; });
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i], it = items[i];
      if (String(ln.getAttribute('data-vid')) !== String(it.variant_id)) return;
      var info = ln.querySelector('.vcd-info');
      var oldI = ln.querySelector('.vipc-issue'); if (oldI) oldI.parentNode.removeChild(oldI);
      var oldR = ln.querySelector('.vipc-req'); if (oldR) oldR.parentNode.removeChild(oldR);
      if (!isCustomLine(it)) continue;
      var d = digitsOf(it);
      if (info && d) { var r = document.createElement('span'); r.className = 'vipc-req'; r.textContent = 'Requested: 07XXX ' + d; info.appendChild(r); }
      if (byIndex[i]) { ln.style.flexWrap = 'wrap'; ln.appendChild(issueBox(byIndex[i])); }
    }
    var foot = dr.querySelector('.vcd-foot');
    var co = foot && foot.querySelector('.vcd-checkout');
    var paused = foot && foot.querySelector('.vipc-paused');
    if (!res.ok) { if (co && !paused) co.parentNode.insertBefore(pausedBox(), co); }
    else if (paused) paused.parentNode.removeChild(paused);
    setBlocked(co, !res.ok);
  }
  // Delivery note under the drawer total (assets/vip-cart-drawer.js always writes "Same-day PAC code").
  // Carts without a custom line keep the drawer's own note unchanged (Available Numbers, eSIM, Pre-Order).
  // Decided from the rendered lines' variant ids, synchronously, so the original note is never painted for a custom cart.
  var NOTE_CUSTOM = 'Custom numbers are normally ready in around 2 weeks';
  var NOTE_MIXED = 'Same-day PAC code for available numbers · Custom numbers are normally ready in around 2 weeks';
  function setDrawerNote(dr) {
    var note = dr && dr.querySelector('.vcd-foot .vcd-note');
    if (!note) return;
    if (!note.hasAttribute('data-vipc-orig')) note.setAttribute('data-vipc-orig', note.textContent);
    var lines = dr.querySelectorAll('.vcd-body .vcd-line[data-vid]');
    var custom = 0, other = 0;
    for (var i = 0; i < lines.length; i++) { if (isCustomVid(lines[i].getAttribute('data-vid'))) custom++; else other++; }
    var txt = !custom ? note.getAttribute('data-vipc-orig') : (other ? NOTE_MIXED : NOTE_CUSTOM);
    if (note.textContent !== txt) note.textContent = txt;
  }
  var drawerTimer = null;
  function watchDrawer() {
    var dr = document.getElementById('vcdDrawer');
    if (!dr) return false;
    var body = dr.querySelector('.vcd-body');
    if (!body || body.__vipcWatch) return true;
    body.__vipcWatch = true;
    new MutationObserver(function () {
      setDrawerNote(dr);
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(function () { validate().then(paintDrawer).catch(function () {}); }, 60);
    }).observe(body, { childList: true });
    setDrawerNote(dr);
    if (body.querySelector('.vcd-line:not(.vcd-pending)')) validate().then(paintDrawer).catch(function () {});
    return true;
  }

  function init() {
    if (!nativeFetch) return;
    onChange(function (res) { paintCartPage(res); paintDrawer(res); });
    validate().catch(function () {});
    if (!watchDrawer()) {
      var obs = new MutationObserver(function () { if (watchDrawer()) obs.disconnect(); });
      obs.observe(document.body, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) validate().catch(function () {}); });

  window.VIPCustom = {
    variants: window.C6D_VARIANTS, getPrice: C6D_getPrice, expectedTier: expectedTier,
    isCustomVid: isCustomVid, isCustomLine: isCustomLine, checkLine: checkLine, checkCart: checkCart,
    validate: validate, checkoutTarget: checkoutTarget, state: state, BUILDER: BUILDER, PROP: PROP
  };
})();
